export default {
  common: {
    projectList: "Lista de proyectos",
    pleaseInputProjectName: "Por favor ingrese el nombre del proyecto",
    pipeline: "Pipeline",
    onhold: "En espera",
    win: "Ganar",
    loss: "Perder",
    city: "Ciudad",
    amount: "Monto",
    winProbability: "Probabilidad de ganar",
    registeredOn: "Registrado en",
    updatedOn: "Actualizado en",
    thereAreNoMoreProjectsLeft: "No quedan más proyectos",

    drafting: "Borrador",
    ready: "Listo",
    shared: "Compartido",
    negotiating: "Negociando",
    secured: "Asegurado",
    lost: "Perdido",
    onhold: "En espera",

    INITIAL: "Preparando informe ECM",
    ECM_REPORT_PREPARED: "Informe ECM pendiente de compartir con el cliente",
    ECM_TO_CUSTOMER: "Informe ECM enviado al cliente",
    CUSTOMER_KIV_PROPOSAL: "Cliente mantiene en vista la propuesta",
    CUSTOMER_FUNDED: "Cliente confirmó financiación del proyecto",
    CUSTOMER_PROPOSAL: "Cliente negociando la propuesta",
    EA_TO_CUSTOMER: "Informe EA enviado al cliente",
    CUSTOMER_ORDERS: "pedidos del cliente",
    LOST_TO_COMPETITION: "Perdido ante la competencia",
    STATUS_PROJECT: "Estado reportado en otro proyecto",
    IN_ACTIVE: "Proyecto en espera",
    getProjectInfoFailed: "Error al obtener la información del proyecto",
    getCitylistFailed: "Error al obtener la lista de ciudades",
    cantGetProjectDetails: "No se pueden obtener los detalles del proyecto",
    noProjectId: "Sin ID de proyecto",
    noProjectState: "Sin estado del proyecto",
    enterProjectName: "Ingrese el nombre del proyecto",

    noActualEcmQuoted: "No se cita el ECM real"
  },
  projectDlg: {
    newProject: "Nuevo proyecto",
    projectName: "Nombre del proyecto",
    projectState: "Estado del proyecto",
    customer: "Cliente",
    address: "Dirección",
    customerEmail: "Correo electrónico del cliente",
    auditDate: "Fecha de auditoría",
    jobsiteCity: "Ciudad del sitio de trabajo",
    estimatedEcmQuoted: "ECM estimado cotizado",
    exceptedOrder: "Fecha de pedido esperada",
    winProbability: "Probabilidad de ganar %",
    saveRetrun: "Guardar y regresar",
    saveAudit: "Guardar y auditar",
    statusRemarks: "Nota de Estado",

    actualEcmQuoted: "Oferta real de ecm",
    actualOrder: "Fecha real del pedido"
  }
}



// WEBPACK FOOTER //
// ./src/locale/projectList/es.js